// extracted by mini-css-extract-plugin
export var aiStarSpin = "_px-1";
export var spinner = "_px-0";